import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { LABEL_STYLES } from "asset/base-theme";
import Text from "component/Text";
import { Tooltip } from "primereact/tooltip";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { generateAlphabetRandomId } from "util/CommonUtil";
import { generateClasses } from "util/Util";

const Label = (props: any) => {
  const {
    label,
    hideLabel,
    labelClassNames,
    labelStyleObj,
    disabled,
    variantType,
    isInvalid,
    mandatory,
    infoPosition,
    info,
    updateLabelClassName,
  } = props;
  const getClassNames = () => {
    const styleObject = {
      ...LABEL_STYLES,
      overrideStyle: labelStyleObj,
      overrideClasses: labelClassNames,
      isInvalid: isInvalid,
      isDisabled: disabled,
    };

    return generateClasses(styleObject, variantType);
  };

  const { t } = useTranslation();

  const infoContent = typeof info === "string" ? t(info) : info;

  const id = generateAlphabetRandomId(8);

  const renderLabelContent = () => {
    if (label)
      return (
        <div
          className={`mb-1 flex items-center ${info ? "gap-1.5" : ""} ${updateLabelClassName ?? ""}`}
        >
          <div className="flex gap-0.5">
            <Text className={`${getClassNames()} `} label={label} />
            {mandatory && <span className="translate-x-1">*</span>}
          </div>

          {info && (
            <div
              id={`${id}-info`}
              className="flex h-6 w-6 cursor-pointer items-center justify-center pt-0.25"
            >
              <InformationCircleIcon className="h-4 w-4 text-dark-neutral-gray-600" />
            </div>
          )}

          <Tooltip
            className="dark-tooltip rounded-toastBorderRadius bg-dark-neutral-gray-800 p-3 text-center text-sm !text-dark-neutral-gray-100"
            target={`#${id}-info`}
            position={infoPosition ?? "top"}
            mouseTrack
            mouseTrackLeft={10}
            mouseTrackTop={10}
            showDelay={70}
            hideDelay={120}
          >
            {infoContent}
          </Tooltip>
        </div>
      );

    if (hideLabel) return <></>;

    return <div className={`mb-1 h-4 `} />;
  };

  return <>{renderLabelContent()}</>;
};

export default memo(Label);
